export default __webpack_public_path__ + "static/media/arish.71731eb6.jfif";